module.exports = "<div class=\"container text-left\">\n  <ul class=\"foot-nav clearfix\">\n    <li><a ui-sref=\"terms\" href=\"#\">TERMS OF SERVICE</a></li>\n    <li><a ui-sref=\"privacy\">PRIVACY POLICY</a></li>\n    <li><a ui-sref=\"use-policy\">ACCEPTABLE USE POLICY</a></li>\n  </ul>\n  <p style=\"margin-top: 14px\">\n      <span class=\"text-primary\">SafeStart Medical, Inc.</span> | All Rights Reserved &copy;  2017\n  </p>\n  <span class=\"badges\">\n    <img src=\"assets/images/white-grid@2x.png\" class=\"badge2\" alt=\"\">\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 72
// module chunks = 0